module.exports = __webpack_public_path__ + "static/img/manual_zh_15.542613f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_15.png
// module id = JLv9
// module chunks = 4